// Header.jsx
import {useState, useEffect, useRef} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useAuth} from '../hooks/useAuth';
import {useLoginModal} from '../contexts/LoginModalContext';
import LoginModal from './loginModal';

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(0);
    const {user, logout} = useAuth();
    const navigate = useNavigate();

    const {isLoginModalOpen, openLoginModal, closeLoginModal, handleLoginSuccess} = useLoginModal();

    const mobileMenuRef = useRef(null);
    const profileDropdownRef = useRef(null);
    const mobileMenuButtonRef = useRef(null);
    const profileButtonRef = useRef(null);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMobileMenuOpen && mobileMenuRef.current && ! mobileMenuRef.current.contains(event.target) && mobileMenuButtonRef.current && ! mobileMenuButtonRef.current.contains(event.target)) {
                setIsMobileMenuOpen(false);
            }

            if (isProfileDropdownOpen && profileDropdownRef.current && ! profileDropdownRef.current.contains(event.target) && profileButtonRef.current && ! profileButtonRef.current.contains(event.target)) {
                setIsProfileDropdownOpen(false);
            }
        };


    }, [isMobileMenuOpen, isProfileDropdownOpen]);

    useEffect(() => {
        if (isMobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return() => {
            document.body.style.overflow = 'auto';
        };
    }, [isMobileMenuOpen]);

    // Desktop navigation के लिए custom handler
    const handleNavLinkClick = (e, path) => {
        e.preventDefault();
        navigate(path);
        setIsProfileDropdownOpen(false);
        setIsMobileMenuOpen(false);
    };

    const handleLoginClick = () => {
        openLoginModal();
        setIsMobileMenuOpen(false);
        setIsProfileDropdownOpen(false);
    };

    const handleLogoutClick = () => {
        logout();
        navigate('/');
        setIsProfileDropdownOpen(false);
        setIsMobileMenuOpen(false);
    };

    const handleProfileClick = () => {
        navigate('/profile');
        setIsProfileDropdownOpen(false);
        setIsMobileMenuOpen(false);
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
        if (!isMobileMenuOpen) {
            setIsProfileDropdownOpen(false);
        }
    };

    const toggleProfileDropdown = () => {
        setIsProfileDropdownOpen(!isProfileDropdownOpen);
        if (!isProfileDropdownOpen) {
            setIsMobileMenuOpen(false);
        }
    };

    const handleMobileNavClick = (path) => {
        navigate(path);
        setIsMobileMenuOpen(false);
        setIsProfileDropdownOpen(false);
    };
    const isLoggedIn = user && user.token;

    return (
        <>
            <header className="sticky top-0 z-50 shadow-lg bg-white">
                <div className="container mx-auto px-4">
                    <div className="flex justify-between items-center py-4">

                        {/* Logo Section */}
                        <Link to="/"
                            onClick={
                                () => {
                                    setIsProfileDropdownOpen(false);
                                    setIsMobileMenuOpen(false);
                                }
                            }
                            className="flex items-center space-x-2">
                            <div className="w-10 h-10 rounded-lg bg-blue-600 flex items-center justify-center">
                                <i className="fas fa-bus text-white text-xl"></i>
                            </div>
                            <div>
                                <h1 className="text-2xl font-bold text-blue-600">
                                    Bus<span className="text-orange-500">Express</span>
                                </h1>
                                <p className="text-xs text-gray-500">Travel Smarter</p>
                            </div>
                        </Link>

                        {/* Desktop Navigation */}
                        <nav className="hidden md:flex space-x-8">
                            <a href="/"
                                onClick={
                                    (e) => handleNavLinkClick(e, '/')
                                }
                                className="font-medium text-blue-600 hover:text-orange-500 transition-colors">
                                Home
                            </a>

                            <Link to="/about-us" className='font-medium text-gray-600 hover:text-blue-600 transition-colors'>About us</Link>

                            <a href="/my-bookings"
                                onClick={
                                    (e) => handleNavLinkClick(e, '/my-bookings')
                                }
                                className="font-medium text-gray-600 hover:text-blue-600 transition-colors">
                                My Bookings
                            </a>
                            <Link to="/contact-us" className='font-medium text-gray-600 hover:text-blue-600 transition-colors'>Contact us</Link>

                        </nav>

                        {/* Auth Section */}
                        <div className="flex items-center space-x-4">
                            {
                            isLoggedIn ? (
                                <> {/* Desktop Profile Dropdown */}
                                    <div className="hidden md:block relative">
                                        <button ref={profileButtonRef}
                                            onClick={toggleProfileDropdown}
                                            className="flex items-center space-x-2 px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors">
                                            <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                                                <i className="fas fa-user text-blue-600"></i>
                                            </div>
                                            <span className="font-medium text-gray-700">
                                                {
                                                user ?. name || user ?. phone || user ?. email || 'User'
                                            } </span>
                                            <i className={
                                                `fas fa-chevron-down text-gray-500 text-xs transition-transform ${
                                                    isProfileDropdownOpen ? 'rotate-180' : ''
                                                }`
                                            }></i>
                                        </button>

                                        {/* Profile Dropdown Menu */}
                                        {
                                        isProfileDropdownOpen && (
                                            <div ref={profileDropdownRef}
                                                className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                                                <div className="py-2">
                                                    <div className="px-4 py-2 border-b border-gray-100">
                                                        <p className="font-medium text-gray-800">
                                                            {
                                                            user ?. name || 'User'
                                                        }</p>
                                                        <p className="text-sm text-gray-500 truncate">
                                                            {
                                                            user ?. email || user ?. phone || ''
                                                        }</p>
                                                    </div>
                                                    <button onClick={handleProfileClick}
                                                        className="w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-50 flex items-center space-x-3">
                                                        <i className="fas fa-user-circle text-blue-500 w-5"></i>
                                                        <span>My Profile</span>
                                                    </button>
                                                    <button onClick={
                                                            () => {
                                                                navigate('/my-bookings');
                                                                setIsProfileDropdownOpen(false);
                                                            }
                                                        }
                                                        className="w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-50 flex items-center space-x-3">
                                                        <i className="fas fa-ticket-alt text-blue-500 w-5"></i>
                                                        <span>My Bookings</span>
                                                    </button>
                                                    <div className="border-t border-gray-100 my-1"></div>
                                                    <button onClick={handleLogoutClick}
                                                        className="w-full text-left px-4 py-3 text-red-600 hover:bg-red-50 flex items-center space-x-3">
                                                        <i className="fas fa-sign-out-alt text-red-500 w-5"></i>
                                                        <span>Logout</span>
                                                    </button>
                                                </div>
                                            </div>
                                        )
                                    } </div>

                                    {/* Mobile Profile Icon */}
                                    <div className="md:hidden relative">
                                        <button ref={profileButtonRef}
                                            onClick={toggleProfileDropdown}
                                            className="flex items-center p-2 rounded-lg hover:bg-gray-100 transition-colors">
                                            <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                                                <i className="fas fa-user text-blue-600"></i>
                                            </div>
                                        </button>

                                        {/* Mobile Profile Dropdown */}
                                        {
                                        isProfileDropdownOpen && (
                                            <div ref={profileDropdownRef}
                                                className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                                                <div className="py-2">
                                                    <div className="px-4 py-2 border-b border-gray-100 bg-blue-50">
                                                        <p className="font-medium text-gray-800">
                                                            {
                                                            user ?. name || 'User'
                                                        }</p>
                                                        <p className="text-sm text-gray-500 truncate">
                                                            {
                                                            user ?. email || user ?. phone || ''
                                                        }</p>
                                                    </div>
                                                    <button onClick={handleProfileClick}
                                                        className="w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-50 flex items-center space-x-3">
                                                        <i className="fas fa-user-circle text-blue-500 w-5"></i>
                                                        <span>My Profile</span>
                                                    </button>
                                                    <button onClick={
                                                            () => {
                                                                navigate('/my-bookings');
                                                                setIsProfileDropdownOpen(false);
                                                            }
                                                        }
                                                        className="w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-50 flex items-center space-x-3">
                                                        <i className="fas fa-ticket-alt text-blue-500 w-5"></i>
                                                        <span>My Bookings</span>
                                                    </button>
                                                    <div className="border-t border-gray-100 my-1"></div>
                                                    <button onClick={handleLogoutClick}
                                                        className="w-full text-left px-4 py-3 text-red-600 hover:bg-red-50 flex items-center space-x-3">
                                                        <i className="fas fa-sign-out-alt text-red-500 w-5"></i>
                                                        <span>Logout</span>
                                                    </button>
                                                </div>
                                            </div>
                                        )
                                    } </div>
                                </>
                            ) : (
                                <> {/* Desktop Login Button */}
                                    <button onClick={handleLoginClick}
                                        className="hidden md:inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                                        <i className="fas fa-sign-in-alt mr-2"></i>
                                        Sign In
                                    </button>

                                    {/* Mobile Login Icon */}
                                    <button onClick={handleLoginClick}
                                        className="md:hidden inline-flex items-center p-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                                        <i className="fas fa-sign-in-alt"></i>
                                    </button>
                                </>
                            )
                        }

                            {/* Mobile Menu Button */}
                            <button ref={mobileMenuButtonRef}
                                onClick={toggleMobileMenu}
                                className="md:hidden text-gray-600 ml-2"
                                aria-label="Toggle menu">
                                <i className={
                                    `fas ${
                                        isMobileMenuOpen ? 'fa-times' : 'fa-bars'
                                    } text-2xl transition-transform`
                                }></i>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Mobile Navigation Menu */}
                {
                isMobileMenuOpen && (
                    <div ref={mobileMenuRef}
                        className="md:hidden fixed top-16 left-0 w-full h-[calc(100vh-4rem)] bg-white shadow-lg z-40 overflow-y-auto">
                        <div className="container mx-auto px-4 py-6">
                            <div className="flex flex-col space-y-1">
                                <button onClick={
                                        () => handleMobileNavClick('/')
                                    }
                                    className="flex items-center space-x-4 px-4 py-4 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors">
                                    <i className="fas fa-home text-lg w-6 text-blue-500"></i>
                                    <span className="font-medium text-lg">Home</span>
                                </button>

                                <button onClick={
                                        () => handleMobileNavClick('/book-tickets')
                                    }
                                    className="flex items-center space-x-4 px-4 py-4 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors">
                                    <i className="fas fa-ticket-alt text-lg w-6 text-blue-500"></i>
                                    <span className="font-medium text-lg">Book Tickets</span>
                                </button>

                                {
                                isLoggedIn && (
                                    <button onClick={
                                            () => handleMobileNavClick('/my-bookings')
                                        }
                                        className="flex items-center space-x-4 px-4 py-4 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors">
                                        <i className="fas fa-bookmark text-lg w-6 text-blue-500"></i>
                                        <span className="font-medium text-lg">My Bookings</span>
                                    </button>
                                )
                            }

                                <button onClick={
                                        () => handleMobileNavClick('/bus-routes')
                                    }
                                    className="flex items-center space-x-4 px-4 py-4 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors">
                                    <i className="fas fa-route text-lg w-6 text-blue-500"></i>
                                    <span className="font-medium text-lg">Bus Routes</span>
                                </button>

                                <button onClick={
                                        () => handleMobileNavClick('/offers')
                                    }
                                    className="flex items-center space-x-4 px-4 py-4 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors">
                                    <i className="fas fa-tag text-lg w-6 text-blue-500"></i>
                                    <span className="font-medium text-lg">Offers</span>
                                </button>

                                {/* Account Section */}
                                <div className="border-t border-gray-200 mt-4 pt-4">
                                    <div className="px-4 py-2">
                                        <p className="text-sm text-gray-500 font-medium mb-2">Account</p>

                                        {
                                        ! isLoggedIn ? (
                                            <button onClick={handleLoginClick}
                                                className="w-full flex items-center justify-center space-x-3 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors mt-2">
                                                <i className="fas fa-sign-in-alt"></i>
                                                <span className="font-medium">Sign In / Register</span>
                                            </button>
                                        ) : (
                                            <div className="space-y-2">
                                                <div className="bg-blue-50 rounded-lg p-3">
                                                    <p className="font-medium text-gray-800">
                                                        {
                                                        user ?. name || 'User'
                                                    }</p>
                                                    <p className="text-sm text-gray-500 truncate">
                                                        {
                                                        user ?. email || user ?. phone || ''
                                                    }</p>
                                                </div>
                                                <button onClick={handleProfileClick}
                                                    className="w-full flex items-center space-x-3 px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors">
                                                    <i className="fas fa-user-circle text-blue-500"></i>
                                                    <span className="font-medium">My Profile</span>
                                                </button>
                                                <button onClick={handleLogoutClick}
                                                    className="w-full flex items-center space-x-3 px-4 py-3 text-red-600 hover:bg-red-50 rounded-lg transition-colors">
                                                    <i className="fas fa-sign-out-alt"></i>
                                                    <span className="font-medium">Logout</span>
                                                </button>
                                            </div>
                                        )
                                    } </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            } </header>

            {/* Overlay for mobile menu */}
            {
            isMobileMenuOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"></div>
            )
        }

            {/* Global Login Modal */}
            <LoginModal isOpen={isLoginModalOpen}
                onClose={closeLoginModal}
                onLoginSuccess={handleLoginSuccess}/>
        </>
    );
}

export default Header;
